import l from './layout.vue';

export default l;
